import { render, staticRenderFns } from "./WeightCounterMenu.vue?vue&type=template&id=3dd11fc6&scoped=true&"
import script from "./WeightCounterMenu.vue?vue&type=script&lang=ts&"
export * from "./WeightCounterMenu.vue?vue&type=script&lang=ts&"
import style0 from "./WeightCounterMenu.vue?vue&type=style&index=0&id=3dd11fc6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd11fc6",
  null
  
)

export default component.exports